import type { ReactElement } from 'react'
import styled from 'styled-components'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'
import { PDFItem } from '@/components/layouts/Ir/PDFItem'

export const BasicsPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Basic Policy"
        subTitleText="コーポレート・ガバナンスに関する基本的な考え方"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Paragraph>
        当社は、お客様の役に立つために、流通小売業界における『ムダ・ムラ・ムリ』をなくすことが、社会の課題解決につながると考えており、『世界の誰もが「豊かさ」を享受できる社会をつくる。』を当社グループのパーパスとしております。
        また、株主・投資家を含むステークホルダーの皆様と協働することが、企業としての持続的な成長と企業価値向上の実現につながると考えております。そのためには、コンプライアンスの徹底、経営の透明性の確保とともに、迅速な意思決定によるスピード経営の実現が重要であり、その仕組みを構築し、機能させることがコーポレート・ガバナンスの基本的な考え方となります。この基本的な考え方に基づき、コーポレート・ガバナンスの継続的な進化と充実に取り組みます。
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 30 }} />
      {/* 3月19日にpdfを共有→3月22日に開示 */}
      <PDFItem
        fileName="コーポレート・ガバナンスに関する報告書"
        filePath="https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/b22d89e6-41c2-4fdb-959f-596c69a0d0a4/TRIAL_CorporateGovernanceReport_260929.pdf"
      />
      <Spacer h={{ sp: 20, pc: 30 }} />
      <PublishDate>2026年9月29日</PublishDate>
    </Layout>
  )
}

BasicsPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir/' },
    { name: 'コーポレート・ガバナンス', path: '/ir/governance/' },
    { name: 'コーポレート・ガバナンスに関する基本的な考え方', path: '' },
  ]

  return (
    <>
      <Head
        title="コーポレート・ガバナンスに関する基本的な考え方"
        description="トライアルホールディングスのコーポレート・ガバナンスに関する基本的な考え方について掲載しています。"
        ogp={{ url: '/ir/governance/basics' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const PublishDate = styled.span`
  display: flex;
  justify-content: flex-end;
`
